const numberFormatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 0,
});

const currencyFormatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatNumber = (value: number): string => numberFormatter.format(value);

export const formatCurrency = (
  value: number,
  currencyCode = "BDT"
): string => `${currencyCode} ${currencyFormatter.format(value)}`;
